import { Button, Checkbox, Drawer, Flex, LoadingOverlay, Modal, Paper, Text, Tooltip } from "@mantine/core";
import {
  IconCircleCheck,
  IconCircleMinus,
  IconEdit,
  IconInfoSquareRounded,
  IconMailForward,
  IconMailOpened,
  IconReload,
  IconSend,
  IconTrash,
} from "@tabler/icons-react";
import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { PartnerApi } from "../../apis";
import { IAdmin } from "../../interfaces/IAdmin";
import { IGeneral } from "../../interfaces/IGeneral";
import { IReference } from "../../models/General";
import { Dialog } from "../../utils/confirm-modal";
import { dateSecFormat } from "../../utils/date";
import HttpHandler from "../../utils/http-handler";
import { Message } from "../../utils/message";
import { ColumnType, ITableRef, Table } from "../table";
import { Tag } from "../tags";
import RenderText from "../ui/render-text";
import { PartnerManagementAdminInviteForm } from "./invite-form";
import { ManagerForm } from "./manager-form";

export function DehubFinanceList({ actionType }: { actionType: any }) {
  const params = useParams();
  const ref = useRef<ITableRef>(null);
  const [action, setAction] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const userStatus = useSelector((state: { general: IGeneral }) => state.general.userStatus);
  const userRegisterStatus = useSelector((state: { general: IGeneral }) => state.general.userRegisterStatus);

  const [filters] = useState({ partnerId: `${params.id}` });

  const reload = () => {
    ref.current?.reload();
  };

  const columns = useHeader({
    userStatus,
    loading,
    userRegisterStatus,
    actionType,
    onClick: (key, record) => {
      switch (key) {
        case "edit": {
          setAction(["update", record as any]);
          break;
        }
        case "details": {
          setAction(["detail", record as any]);
          return;
        }
        case "remove": {
          Dialog.confirm("Та устгахдаа илгээхдээ итгэлтэй байна уу?", async (key) => {
            switch (key) {
              case "confirm": {
                setLoading(true);
                try {
                  await PartnerApi.removeAdmin(record?.id);
                  reload();
                  Message.success("Амжилттай устгалаа.");
                } catch (err: any) {
                  Message.error((err as HttpHandler)?.message!);
                }
                setLoading(false);
                break;
              }
              default:
            }
          });
          break;
        }
        case "send": {
          setAction(["INVITE", record as any]);
          break;
        }
        case "otp": {
          Dialog.confirm("Та нэг удаагийн нууц үг дахин илгээхдээ итгэлтэй байна уу?", async (key) => {
            switch (key) {
              case "confirm": {
                setLoading(true);
                try {
                  await PartnerApi.remove(record?.id);
                  reload();
                  Message.success("Амжилттай илгээгдлээ.");
                } catch (err: any) {
                  Message.error((err as HttpHandler)?.message!);
                }
                setLoading(false);
                break;
              }
              default:
            }
          });
          break;
        }
        case "password": {
          Dialog.confirm("Та нууц үг сэргээх мэйл илгээхдээ итгэлтэй байна уу ?", async (key) => {
            switch (key) {
              case "confirm": {
                setLoading(true);
                try {
                  await PartnerApi.remove(record?.id);
                  reload();
                  Message.success("Амжилттай илгээгдлээ.");
                } catch (err: any) {
                  Message.error((err as HttpHandler)?.message!);
                }
                setLoading(false);
                break;
              }
              default:
            }
          });
          break;
        }
        case "active": {
          Dialog.confirm("Та админ хэрэглэгчийг идэвхтэй болгох гэж байна итгэлтэй байна уу!", async (key) => {
            switch (key) {
              case "confirm": {
                setLoading(true);
                try {
                  await PartnerApi.adminActive(record?.partnerId, record?.id, { type: "DEHUB_FINANCE" });
                  Message.success("Амжилттай идэвхтэй болгосон.");
                } catch (err) {
                  Message.error((err as HttpHandler)?.message!);
                }
                reload();
                setLoading(false);
                break;
              }
              default:
            }
          });
          break;
        }
        case "in_active": {
          Dialog.confirm("Та админ хэрэглэгчийг идэвхгүй болгох гэж байна итгэлтэй байна уу!", async (key) => {
            switch (key) {
              case "confirm": {
                setLoading(true);
                try {
                  await PartnerApi.adminInActive(record?.partnerId, record?.id, { type: "DEHUB_FINANCE" });
                  Message.success("Амжилттай идэвхгүй болгосон.");
                } catch (err) {
                  Message.error((err as HttpHandler)?.message!);
                }
                reload();
                setLoading(false);
                break;
              }
              default:
            }
          });
          break;
        }
      }
    },
  });

  if (loading) return <LoadingOverlay visible={loading} />;

  return (
    <Paper>
      <Flex align="center" justify="space-between" gap="md" mb="md">
        <Text tt="uppercase" c="gray">
          DeHUB санхүүгийн хэрэглэгчдийн жагсаалт
        </Text>
        <Button
          onClick={() => {
            setAction(["new"]);
          }}
          disabled={actionType[0] === "detail"}
          key={2}>
          DeHUB санхүү нэмэх
        </Button>
      </Flex>

      <Table ref={ref} name="dehub-finance.list" columns={columns} filters={filters} loadData={(data) => PartnerApi.adminList(data!)} />
      <Drawer
        withCloseButton={false}
        title={false}
        position="right"
        padding={"lg"}
        size={"70%"}
        opened={action[0] === "new" || action[0] === "update" || action[0] === "detail"}
        onClose={() => setAction([])}>
        <ManagerForm type="DEHUB_FINANCE" reload={reload} action={action} setAction={setAction} />
      </Drawer>
      <Modal opened={action[0] === "INVITE"} onClose={() => setAction([])} withCloseButton={false} size="50%" centered>
        <PartnerManagementAdminInviteForm action={action} setAction={setAction} reload={reload} />
      </Modal>
    </Paper>
  );
}

const useHeader = ({
  onClick,
  userStatus,
  userRegisterStatus,
  actionType,
}: {
  actionType: any;
  onClick: (key: string, record: IAdmin) => void;
  userStatus: IReference[];
  userRegisterStatus: IReference[];
  loading: boolean;
}): ColumnType<IAdmin>[] => [
  {
    title: "#",
    width: "30px",
    render: (_r, index) => <RenderText text={index + 1} />,
  },
  {
    title: "Үйлдэл",
    width: "120px",
    render: (record) => {
      return actionType[0] === "detail" ? (
        <>-</>
      ) : (
        <Flex gap="sm">
          {record?.registerStatus !== "SUCCESS" && (
            <Tooltip label="Засварлах" position="bottom">
              <Button variant="light" radius={100} w={35} h={35} p={0} onClick={() => onClick("edit", record)}>
                <IconEdit />
              </Button>
            </Tooltip>
          )}
          <Tooltip label="Дэлгэрэнгүй" position="top">
            <Button variant="light" radius={100} w={35} h={35} p={0} onClick={() => onClick("details", record)}>
              <IconInfoSquareRounded />
            </Button>
          </Tooltip>
          {record?.registerStatus === "DRAFT" && (
            <Tooltip label="Урилга илгээх" position="top">
              <Button variant="light" radius={100} w={35} h={35} p={0} onClick={() => onClick("send", record)}>
                <IconMailForward />
              </Button>
            </Tooltip>
          )}
          {record?.registerStatus === "INVITED" && (
            <Tooltip label="Урилга дахин илгээх" position="top">
              <Button variant="light" radius={100} w={35} h={35} p={0} onClick={() => onClick("send", record)}>
                <IconMailOpened />
              </Button>
            </Tooltip>
          )}
          {record?.registerStatus === "PARTIAL" && (
            <Tooltip label="Урилга илгээх" position="top">
              <Button variant="light" radius={100} w={35} h={35} p={0} onClick={() => onClick("send", record)}>
                <IconMailForward stroke={0.4} />
              </Button>
            </Tooltip>
          )}
          {record?.registerStatus === "INVITED" ||
            (record?.registerStatus === "DRAFT" && (
              <Tooltip label="Устгах" position="top">
                <Button variant="light" radius={100} w={35} h={35} p={0} onClick={() => onClick("remove", record)}>
                  <IconTrash />
                </Button>
              </Tooltip>
            ))}
          {record?.registerStatus === "PARTIAL" && record?.isPhoneVerified === false && record?.isEmailVerified === true && (
            <Tooltip label="OTP илгээх" position="top">
              <Button variant="light" radius={100} w={35} h={35} p={0} onClick={() => onClick("otp", record)}>
                <IconReload />
              </Button>
            </Tooltip>
          )}
          {record?.hasPassword === false && record?.isPhoneVerified === true && record?.isEmailVerified === true && (
            <Tooltip label="Нууц үг сэргээх мэйл илгээх" position="top">
              <Button variant="light" radius={100} w={35} h={35} p={0} onClick={() => onClick("password", record)}>
                <IconSend size={20} style={{ transform: "rotate(45deg)" }} />
              </Button>
            </Tooltip>
          )}
          {record?.isDehubFinance === false && (
            <Tooltip label="DeHUB санхүү болгох" position="bottom">
              <Button variant="light" color="red" radius={100} w={35} h={35} p={0} onClick={() => onClick("active", record)}>
                <IconCircleMinus />
              </Button>
            </Tooltip>
          )}
          {actionType[1]?.adminId !== null && record?.isDehubFinance === true && (
            <Tooltip label="DeHUB санхүүгийн эрх хасах" position="bottom">
              <Button variant="light" color="green" radius={100} w={35} h={35} p={0} onClick={() => onClick("in_active", record)}>
                <IconCircleCheck />
              </Button>
            </Tooltip>
          )}
        </Flex>
      );
    },
  },
  {
    title: "Хэрэглэгчийн нэр",
    sorter: true,
    dataIndex: "username",
    render: (record) => <RenderText text={record?.username || "-"} />,
  },
  {
    title: "Ургийн овог",
    sorter: true,
    dataIndex: "familyName",
    render: (record) => <RenderText text={record?.familyName || "-"} />,
  },
  {
    title: "Эцэг эхийн нэр",
    sorter: true,
    dataIndex: "lastName",
    render: (record) => <RenderText text={record?.lastName || "-"} />,
  },
  {
    title: "Өөрийн нэр",
    sorter: true,
    dataIndex: "firstName",
    render: (record) => <RenderText text={record?.firstName || "-"} />,
  },
  {
    title: "Регистр №",
    sorter: true,
    dataIndex: "registerNo",
    render: (record) => <RenderText text={record?.registerNo || "-"} />,
  },
  {
    title: "Нэгжийн нэр",
    sorter: true,
    dataIndex: "departmentUnitId",
    render: (record) => <RenderText text={record?.departmentUnitId || "-"} />,
  },
  {
    title: "Албан тушаал",
    sorter: true,
    dataIndex: "employeeUnitId",
    render: (record) => <RenderText text={record?.employeeUnitId || "-"} />,
  },
  {
    title: "И-мэйл хаяг",
    sorter: true,
    dataIndex: "email",
    render: (record) => <RenderText text={record?.email || "-"} />,
  },
  {
    title: "Утас 1",
    sorter: true,
    dataIndex: "phone",
    render: (record) => <RenderText text={record?.phone || "-"} />,
  },
  {
    title: "Утас 2",
    sorter: true,
    dataIndex: "phone2",
    render: (record) => <RenderText text={record?.phone2 || "-"} />,
  },
  {
    title: "Бүртгэсэн огноо",
    sorter: true,
    dataIndex: "createdAt",
    render: (record) => <RenderText text={dateSecFormat(record?.createdAt)} />,
  },
  {
    title: "Хэрэглэгч статус",
    sorter: true,
    dataIndex: "itemStatus",
    render: (record) => (
      <Tag
        color={userStatus.find((item: IReference) => item.code === record.userStatus)?.color || "gray.5"}
        name={userStatus.find((item: IReference) => item.code === record.userStatus)?.name || "-"}
      />
    ),
  },
  {
    title: "Статус (Бүртгэл баталгаажилт)",
    sorter: true,
    dataIndex: "itemStatus",
    render: (record) => (
      <Tag
        color={userRegisterStatus?.find((item: IReference) => item.code === record.registerStatus)?.color || "gray.5"}
        name={userRegisterStatus?.find((item: IReference) => item.code === record.registerStatus)?.name || "-"}
      />
    ),
  },
  {
    title: "Утас (Бүртгэл баталгаажилт)",
    sorter: true,
    dataIndex: "isPhoneVerified",
    render: (record) => (
      <Flex align="center" gap="xs">
        <Checkbox onChange={() => {}} checked={record.isPhoneVerified} />
        <RenderText text={record.isPhoneVerified ? "Тийм" : "Үгүй"} />
      </Flex>
    ),
  },
  {
    title: "И-мэйл (Бүртгэл баталгаажилт)",
    sorter: true,
    dataIndex: "isEmailVerified",
    render: (record) => (
      <Flex align="center" gap="xs">
        <Checkbox onChange={() => {}} checked={record.isEmailVerified} />
        <RenderText text={record.isEmailVerified ? "Тийм" : "Үгүй"} />
      </Flex>
    ),
  },
  {
    title: "Нууц үг (Бүртгэл баталгаажилт)",
    sorter: true,
    dataIndex: "hasPassword",
    render: (record) => (
      <Flex align="center" gap="xs">
        <Checkbox onChange={() => {}} checked={record.hasPassword} />
        <RenderText text={record.hasPassword ? "Тийм" : "Үгүй"} />
      </Flex>
    ),
  },
  {
    title: "Төр (Бүртгэл баталгаажилт)",
    sorter: true,
    dataIndex: "isDanVerified",
    render: (record) => (
      <Flex align="center" gap="xs">
        <Checkbox onChange={() => {}} checked={record.isDanVerified} />
        <RenderText text={record.isDanVerified ? "Тийм" : "Үгүй"} />
      </Flex>
    ),
  },
];
